<template>
  <div class="flex gap-1 items-center text-xl mb-0">
    <font-awesome-icon icon="file-contract" :color="period.getIconColor()"/>
    <span class="ml-1 font-semibold"> {{ titleString }} </span>
    <span v-if="period.isFinished()" class="text-sm" v-tooltip="resultTooltip">
      {{ resultString }}
    </span>
  </div>
</template>
<script lang="ts">
import YieldPromiseStatus from '@/domain/model/business/YieldPromiseStatus.ts';
import { formatAsDate } from '@/infrastructure/support/utils/DateTimeUtils.ts';

export default {
  name: 'LongTermPeriodTitle',
  props: {
    period: { type: YieldPromiseStatus },
  },
  computed: {
    resultString() {
      const sign = this.period.getCurrentRealizedPct().gt(0) ? '+' : '';
      return `(${sign}${this.period.getCurrentRealizedPct()})`;
    },
    resultTooltip() {
      return this.period.getMissingEnergy().toString();
    },
    titleString() {
      return this.$t('features.long_term.explainer.period_title', {
        start: formatAsDate(this.period.getPeriodStart()),
        end: formatAsDate(this.period.getPeriodEnd()),
      });
    },
  },
};
</script>
